import {EvButton} from '../../form/EvButton';
import {useCalculationGoldImportUmicoreMutation} from './use-calculation-gold-import-umicore-mutation';
import {sub} from 'date-fns';
import {EvDateFns} from '../../components/ev-date-fns';

interface Props {
  now: Date;
}

export function CalculationGoldImportUmicoreForm(props: Props) {
  const importUmicoreMutation = useCalculationGoldImportUmicoreMutation();

  const importUmicore: () => void = () => {
    importUmicoreMutation.mutate({});
  };

  return <>
    <div className="row">
      <div className="col-lg-12">
        <h3>Liste automatisch mit Umicore abgleichen</h3>
        <p>
          Mit dieser Funktion wird die Liste direkt mit den Preisen von Umicore
          zwischen <EvDateFns date={sub(props.now, {days: 8})}/>
          &nbsp;und <EvDateFns date={sub(props.now, {days: 1})}/> abgeglichen.
          Veränderte / neue Preise werden markiert.
        </p>
      </div>
    </div>
    <div className="row">
      <div className="col-lg-12 text-right">
        <EvButton disabled={importUmicoreMutation.isPending}
                  onClick={importUmicore}>
          Liste mit Umicore abgleichen
        </EvButton>
      </div>
    </div>
  </>;
}
